import { getAxiosInstance } from '../utils/axios'
import axios from 'axios'

const resourceBucket = '/second-brain/documents'

export const getPresignedUrl = async (fileName: string, fileId?: string, qc = false) => {
	try {
		const axiosInstance = await getAxiosInstance()
		let url = `${resourceBucket}/presigned-url?file_name=${fileName}`
		if (fileId) {
			url = `${url}&file_id=${fileId}`
		}
		if (qc) {
			url = `${url}&qc=true`
		}
		const response = await axiosInstance.get(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const postPresignedUrl = async (presignedUrl: string, formData: any) => {
	try {
		const response = await axios.post(presignedUrl, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const getUploadedDocuments = async (qc = false) => {
	try {
		const axiosInstance = await getAxiosInstance()
		let url = resourceBucket
		if (qc) {
			url = `${url}?qc=true`
		}
		const response = await axiosInstance.get(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const deleteDocument = async (fileId: string, qc = false) => {
	try {
		const axiosInstance = await getAxiosInstance()
		let url = `${resourceBucket}/${fileId}`
		if (qc) {
			url = `${url}?qc=true`
		}
		const response = await axiosInstance.delete(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const downloadDocument = async (fileId: string, qc = false) => {
	try {
		const axiosInstance = await getAxiosInstance()
		let url = `${resourceBucket}/download/${fileId}`
		if (qc) {
			url = `${url}?qc=true`
		}
		const response = await axiosInstance.get(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const readDocument = async (url: string) => {
	try {
		const response = await axios.get(url)
		return response.data
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const ingestFile = async (fileData: any) => {
	try {
		const axiosInstance = await getAxiosInstance()
		const response = await axiosInstance.post(`${resourceBucket}/ingest`, fileData)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const qcDocument = async (fileId: string) => {
	try {
		const axiosInstance = await getAxiosInstance()
		const url = `${resourceBucket}/${fileId}/qc`
		const response = await axiosInstance.post(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const qcAllDocuments = async () => {
	try {
		const axiosInstance = await getAxiosInstance()
		const url = `${resourceBucket}/qc`
		const response = await axiosInstance.post(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const getQCResults = async (fileId: string) => {
	try {
		const axiosInstance = await getAxiosInstance()
		const url = `${resourceBucket}/${fileId}/qc`
		const response = await axiosInstance.get(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}

export const listQCResults = async () => {
	try {
		const axiosInstance = await getAxiosInstance()
		const url = `${resourceBucket}/qc`
		const response = await axiosInstance.get(url)
		return response
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message)
		} else {
			throw new Error('Unknown error')
		}
	}
}
